import { IMAGES } from "../content";
import { Eyebrow, HudCorners, Reveal } from "./bits";

const About = ({ t }) => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-36 bg-[#F2F5F9] border-y border-[#CBD3DF] overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: `url(${IMAGES.facility})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>{t.eyebrow}</Eyebrow>
          <h2 className="mt-5 font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0B0D10]">
            {t.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {t.chapters.map((ch, i) => (
            <Reveal key={ch.num} delay={i * 0.12}>
              <div
                data-testid={`manifesto-chapter-${i + 1}`}
                className="group relative h-full bg-[#FFFFFF]/80 backdrop-blur border border-[#CBD3DF] p-7 sm:p-8 rounded-sm hover:border-emerald/50 transition-colors duration-500"
              >
                <span className="font-display font-extrabold text-5xl text-[#CBD3DF] group-hover:text-emerald/25 transition-colors duration-500">
                  {ch.num}
                </span>
                <h3 className="mt-5 font-display font-bold uppercase tracking-wide text-xl text-[#0B0D10]">
                  {ch.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-neutral-700">{ch.desc}</p>
                <HudCorners className="border-transparent group-hover:border-emerald/50 transition-colors duration-500" />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div data-testid="about-stats-grid" className="mt-16 grid grid-cols-2 lg:grid-cols-4 border border-[#CBD3DF] rounded-sm divide-x divide-y lg:divide-y-0 divide-[#CBD3DF] bg-[#E9EDF3]/60">
            {t.stats.map((s, i) => (
              <div key={i} className="p-7 sm:p-9 text-center">
                <div className="font-display font-extrabold text-3xl sm:text-4xl text-emerald">{s.value}</div>
                <div className="mt-2 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-neutral-600">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
